import React from "react";

interface RatingModalProps {
  open: boolean;
  rating: number;
  hoverRating: number;
  reviewText: string;
  onClose: () => void;
  onRatingChange: (rating: number) => void;
  onHoverRatingChange: (hover: number) => void;
  onReviewTextChange: (text: string) => void;
  onSubmit: () => void;
  image?: string;
  title?: string;
  description?: string;
}

const RatingModal: React.FC<RatingModalProps> = ({
  open,
  rating,
  hoverRating,
  reviewText,
  onClose,
  onRatingChange,
  onHoverRatingChange,
  onReviewTextChange,
  onSubmit,
  image = "/assets/images/image-movie.webp",
  title = "Đánh giá trải nghiệm",
  description = "Bộ phim này xứng đáng bao nhiêu điểm?",
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-[#232323] rounded-lg p-6 w-[350px] flex flex-col items-center relative">
        <button className="absolute top-0 right-0 p-2 text-white text-xl" onClick={onClose}>
            <img src="/assets/icons/close.svg" alt="close" className="w-6 h-6" />
        </button>
        <img src={image} alt="movie" className="w-[100px] h-[100px] object-cover rounded mb-3" />
        <h3 className="text-lg font-semibold mb-1 text-white text-center">{title}</h3>
        <p className="text-xs text-gray-400 mb-4 text-center">{description}</p>
        <div className="flex gap-1 mb-4">
          {[...Array(10)].map((_, i) => (
            <img
              key={i}
              src={i < (hoverRating || rating) ? "/assets/icons/star-off.svg" : "/assets/icons/star.svg"}
              alt={i < (hoverRating || rating) ? "star-on" : "star-off"}
              className="w-6 h-6 cursor-pointer transition-transform duration-150 hover:scale-110"
              onMouseEnter={() => onHoverRatingChange(i + 1)}
              onMouseLeave={() => onHoverRatingChange(0)}
              onClick={() => onRatingChange(i + 1)}
            />
          ))}
        </div>
        <textarea
          className="w-full rounded bg-[#181818] text-white p-2 mb-4 resize-none focus:outline-none"
          rows={3}
          placeholder="Nhập nội dung đánh giá..."
          value={reviewText}
          onChange={e => onReviewTextChange(e.target.value)}
        />
        <button
          className="bg-primary text-white px-6 py-2 rounded-full w-full font-semibold transition-all duration-200 disabled:opacity-60"
          disabled={rating === 0}
          onClick={onSubmit}
        >
          Gửi đánh giá
        </button>
      </div>
    </div>
  );
};

export default RatingModal;
